import { render } from "./view_digital_form.vue?vue&type=template&id=5dcc9fe9"
import script from "./view_digital_form.js?vue&type=script&lang=js"
export * from "./view_digital_form.js?vue&type=script&lang=js"

import "./view_digital_form.vue?vue&type=style&index=0&id=5dcc9fe9&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__